module.exports = __webpack_public_path__ + "img/dashboard_en_mobile.32a05c7.png";